import React from 'react';
import LegalLayout from './LegalLayout';
import { useAuth } from '../../App';

const Imprint = () => {
  const { language } = useAuth();
  const isDe = language === 'de';

  return (
    <LegalLayout
      title={isDe ? 'Impressum' : 'Imprint'}
      updated={isDe ? '12. Februar 2026' : 'February 12, 2026'}
      testId="imprint-page"
    >
      <h2>{isDe ? 'Betreiber' : 'Operator'}</h2>
      <p>
        <strong>Padelarena Wädenswil</strong><br />
        {isDe ? 'Anschrift folgt' : 'Address to follow'}<br />
        8820 Wädenswil<br />
        {isDe ? 'Schweiz' : 'Switzerland'}
      </p>

      <h2>{isDe ? 'Kontakt' : 'Contact'}</h2>
      <p>
        {isDe ? 'E-Mail' : 'Email'}:{' '}
        <a href="mailto:info@padelarena.ch">info@padelarena.ch</a><br />
        Web: <a href="https://bookpadelarena.ch">bookpadelarena.ch</a>
      </p>

      <h2>{isDe ? 'Handelsregister / UID' : 'Commercial register / VAT'}</h2>
      <p className="text-slate-500 italic">
        {isDe
          ? 'Angaben folgen (UID / Handelsregister-Eintrag)'
          : 'Details to follow (VAT ID / commercial register entry)'}
      </p>

      <h2>{isDe ? 'Haftungsausschluss' : 'Disclaimer'}</h2>
      <p>
        {isDe
          ? 'Alle Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Externe Links wurden bei der Verknüpfung geprüft; für den Inhalt verlinkter externer Seiten sind ausschliesslich deren Betreiber verantwortlich.'
          : 'All content on this website has been created with the utmost care. However, we do not guarantee the accuracy, completeness or timeliness of the content. External links were checked at the time of linking; the operators of the linked external sites are solely responsible for their content.'}
      </p>

      <h2>{isDe ? 'Urheberrecht' : 'Copyright'}</h2>
      <p>
        {isDe
          ? 'Alle Inhalte (Text, Bilder, Grafiken, Logos) sind urheberrechtlich geschützt. Jede Verwendung ausserhalb der engen Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung.'
          : 'All content (text, images, graphics, logos) is protected by copyright. Any use outside the narrow limits of copyright law requires written consent.'}
      </p>

      <h2>{isDe ? 'Technischer Betrieb' : 'Technical operation'}</h2>
      <p>
        {isDe ? 'Diese Plattform läuft auf' : 'This platform runs on'}{' '}
        <strong>Padlr.</strong> — {isDe ? 'dem anpassbaren smarten Buchungssystem für Padel-Center.' : 'the customizable smart booking system for padel centres.'}
      </p>
    </LegalLayout>
  );
};

export default Imprint;
